<template>
  <div v-if="data && data.length > 0" class="mt-[32px] sm:mt-6">
    <div class="flex items-center justify-center gap-2">
      <span
        @click="prevPage"
        :class="[
          currentPage === 1 ? 'pointer-events-none opacity-70' : '',
          mode === 'dark'
            ? 'border-dark-border text-dark-text'
            : 'border-border-10 text-black-60',
        ]"
        class="mr-3 flex h-[48px] w-[48px] cursor-pointer items-center justify-center rounded-md border text-[14px] font-medium transition-colors duration-200 hover:border-primary-100 hover:text-primary-100 sm:mr-0 sm:h-[40px] sm:w-[40px]"
      >
        <ArrowLeft :size="20" :stroke-width="1.75" />
      </span>
      <span
        v-for="page in paginationPages"
        :key="page"
        @click="goToPage(page)"
        class="flex h-[48px] w-[48px] cursor-pointer items-center justify-center rounded-md border text-[14px] font-medium transition-colors duration-200 sm:h-[40px] sm:w-[40px]"
        :class="[
          currentPage === page
            ? 'bg-primary-100 text-white-100'
            : 'hover:border-primary-100 hover:text-primary-100',
          mode === 'dark'
            ? 'border-dark-border text-dark-text'
            : 'border-border-10 text-black-60',
        ]"
      >
        {{ page }}
      </span>
      <span
        @click="nextPage"
        :class="[
          currentPage === totalPages ? 'pointer-events-none opacity-70' : '',
          mode === 'dark'
            ? 'border-dark-border text-dark-text'
            : 'border-border-10 text-black-60',
        ]"
        class="ml-3 flex h-[48px] w-[48px] cursor-pointer items-center justify-center rounded-md border text-[14px] font-medium transition-colors duration-200 hover:border-primary-100 hover:text-primary-100 sm:ml-0 sm:h-[40px] sm:w-[40px]"
      >
        <ArrowRight :size="20" :stroke-width="1.75" />
      </span>
    </div>
  </div>
</template>

<script>
import { ArrowLeft, ArrowRight } from "lucide-vue-next";

export default {
  name: "Pagination",
  props: {
    mode: String,
    data: {
      type: Array,
      default: [],
    },
  },
  components: {
    ArrowLeft,
    ArrowRight,
  },
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
    };
  },
  methods: {
    goToPage(page) {
      if (page === "...") return;
      this.currentPage = page;
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },
    emitPaginatedData() {
      this.$emit("pageChanged", this.paginatedData);
    },
  },
  computed: {
    totalPages() {
      return Math.ceil(this.data.length / this.itemsPerPage);
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.data.slice(start, start + this.itemsPerPage);
    },
    paginationPages() {
      const pages = [];
      if (this.totalPages <= 4) {
        for (let i = 1; i <= this.totalPages; i++) {
          pages.push(i);
        }
      } else {
        if (this.currentPage <= 4) {
          pages.push(1, 2, 3, 4, "...", this.totalPages);
        } else if (this.currentPage >= this.totalPages - 3) {
          pages.push(
            1,
            "...",
            this.totalPages - 4,
            this.totalPages - 3,
            this.totalPages - 2,
            this.totalPages - 1,
            this.totalPages,
          );
        } else {
          pages.push(
            1,
            "...",
            this.currentPage - 1,
            this.currentPage,
            this.currentPage + 1,
            "...",
            this.totalPages,
          );
        }
      }
      return pages;
    },
  },
  watch: {
    currentPage: "emitPaginatedData",
    data: {
      // A new result set starts at page 1 - without this, searching while on
      // page 3 leaves you on page 3 of entirely different data.  Assigning
      // currentPage fires the watcher above, which emits; so only emit here
      // when it is already 1 and that assignment would be a no-op.
      handler() {
        if (this.currentPage === 1) this.emitPaginatedData();
        else this.currentPage = 1;
      },
      immediate: true,
    },
  },
};
</script>
